import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Catalog"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 1.5H6C5.17157 1.5 4.5 2.17157 4.5 3V6H3V7.5H4.5V11.25H3V12.75H4.5V16.5H3V18H4.5V21C4.5 21.8284 5.17157 22.5 6 22.5H19.5C20.3284 22.5 21 21.8284 21 21V3C21 2.17157 20.3284 1.5 19.5 1.5ZM13.5 7.5H19.5V3H6V6H7.5V7.5H6V11.25H7.5V12.75H6V16.5H7.5V18H6V21H19.5V19.5H13.5V18H19.5V14.25H13.5V12.75H19.5V9H13.5V7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Catalog.vue"]]);
